/**
 * Chuyển đổi ngày từ định dạng YYYY-MM-DD sang dd/mm/yyyy (Việt Nam)
 * @param {string} dateString - Chuỗi ngày gốc (YYYY-MM-DD)
 * @returns {string} Chuỗi ngày đã format (dd/mm/yyyy)
 */
export const formatDateDisplay = (dateString) => {
    if (!dateString) return '';
    
    // Tách chuỗi ngày gốc YYYY-MM-DD
    const parts = dateString.split('-');
    
    // Kiểm tra tính hợp lệ cơ bản
    if (parts.length !== 3) return dateString;
    
    const [year, month, day] = parts;
    
    // Trả về định dạng dd/mm/yyyy
    return `${day}/${month}/${year}`;
};

export const formatDateTime = (isoString) => {
    if (!isoString) return '---';
    const date = new Date(isoString);
    return date.toLocaleString('vi-VN', { 
        hour: '2-digit', minute: '2-digit', 
        day: '2-digit', month: '2-digit', year: 'numeric' 
    });
};